import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import {buildRoute} from '../../../configs/routes';
import ModalBaseLayout from '../ModalBaseLayout';
import URL_MAP from '../../../constants/urls';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import defaultUserImage from '../../../assets/images/required/user.png';
import {getUserNameFromString} from '../../../services/common';

const ModalVideoPollRecordInvite = ({videoPollId, user, date}) => {
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const settings = ModalBaseLayout.getInitialSettings({
    className: 'modal-center',
  });
  const dispatch = useDispatch();

  const closeModal = useCallback(() => {
    dispatch(ActionModalHide());
  }, []);

  const onPutOff = useCallback(() => {
    setShowDeclineModal(true);
  }, []);

  const onAccept = useCallback(() => {
    dispatch(ActionRouteNavigate(buildRoute(URL_MAP.VIDEO_POLLS, videoPollId, URL_MAP.START)));
    dispatch(ActionModalHide());
  }, [videoPollId]);

  const inviteDate = moment(new Date(date)).format('DD.MM.YYYY, HH:mm');

  const userName = getUserNameFromString(user.name, true);

  return (
    <ModalBaseLayout {...settings}>
      <div className="modal-inner">
        <div className="modal-container modal-info">
          {showDeclineModal && (
            <div className="modal-content">
              <h3>Отклонение видеоопроса</h3>
              <p className="text-dark text-sm margin-b-10">
                На текущий момент Вы откладываете прохождение видеоопроса.
              </p>
              <p className="text-dark text-sm margin-b-10">Надеемся, что в дальнейшем Вы его пройдёте.</p>
              <p className="text-dark text-sm margin-b-10">
                Не откладывайте на долго, станьте более привлекательными для работодателей и кадровых агенств
              </p>
              <div className="button-group-wrap">
                <button className="btn btn-base" onClick={closeModal}>Принять</button>
              </div>
            </div>
          )}
          {!showDeclineModal && (
            <div className="modal-content">
              <h3>Приглашение на видеоопрос</h3>
              <p className="text-dark text-sm margin-b-10">Вам отправлено приглашение на видеоопрос</p>
              <p className="text-dark text-sm margin-b-10">
                Дата и время:&nbsp;
                <b>{inviteDate}</b>
              </p>
              <div className="send-panel-inner">
                <div className="row align-centr">
                  <div className="col-sm-3">
                    <span className="text-sm text-dark margin-r-10">Пользователь:</span>
                  </div>
                  <div className="col-sm-9 text-dark flex align-centr">
                    <div className="image-wrap">
                      <div className="user-image">
                        <img src={user.photoUrl || defaultUserImage} alt="userName" />
                      </div>
                    </div>
                    <b>{userName}</b>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <button className="btn btn-conture btn-block margin-r-10" onClick={onPutOff}>Отложить</button>
                </div>
                <div className="col-sm-6">
                  <button className="btn btn-base btn-block" onClick={onAccept}>Принять</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </ModalBaseLayout>
  );
};

ModalVideoPollRecordInvite.propTypes = {
  videoPollId: PropTypes.string.isRequired,
  user: PropTypes.shape({}).isRequired,
  date: PropTypes.number.isRequired,
};

export default ModalVideoPollRecordInvite;
